export const url = {
  year: '/auth/market/yearList',
  segment: '/auth/market/segmentList',
  marketSegment: '/auth/market/marketSegmentList',
  country: '/auth/market/countryList',
  brandCagr: '/auth/market/brandCagr',
  brandSalesVolume: '/auth/market/brandSalesVolume',
  overview: '/auth/market/overview',
  yearSalesVolume: '/auth/market/yearSalesVolume'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/marketOverview.js